import React from 'react';
import { ShieldCheckIcon } from '@heroicons/react/24/outline';

const PhotoSelectionTrustSignals: React.FC = () => {
  return (
    <div className="bg-indigo-50/30 rounded-lg border border-indigo-100 p-3">
      <div className="flex items-center">
        <ShieldCheckIcon className="h-5 w-5 text-indigo-600 flex-shrink-0" />
        <p className="ml-2 text-sm text-gray-700">
          <span className="font-medium">We permanently delete your original face after processing</span>
        </p>
      </div>
    </div>
  );
};

export default PhotoSelectionTrustSignals;